import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CommentSection from '../components/CommentSection';

function BlogDetail() {
    const { id } = useParams();  // Get the blog ID from the URL
    const [blog, setBlog] = useState(null);
    const [userRole, setUserRole] = useState(''); // User role state
    const [isEditing, setIsEditing] = useState(false);
    const [updatedBlog, setUpdatedBlog] = useState({});

    // Assume that you get the user role from an API or local storage
    useEffect(() => {
        // Example: Replace with your actual logic to fetch the user's role
        const role = localStorage.getItem('userRole'); // Or fetch from an API
        setUserRole(role);

        fetch(`/api/blogs/${id}`)
            .then(response => response.json())
            .then(data => setBlog(data))
            .catch(error => console.error('Error fetching blog:', error));
    }, [id]);

    const handleEditClick = () => {
        setUpdatedBlog({
            blogname: blog.blogname,
            feedback: blog.feedback,
            image_filename: blog.image_filename
        });
        setIsEditing(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUpdatedBlog(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch(`/api/blogs/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedBlog),
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok.');
            })
            .then(data => {
                setBlog(data);
                setIsEditing(false);
            })
            .catch(error => console.error('Error updating blog:', error));
    };

    if (!blog) {
        return <p>Loading...</p>;
    }

    return (
        <div className="container pt-150 pb-150">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 text-center">
                    <div className="single-latest-news">
                        <div className="news-text-box">
                            <img className="blogdetail-img" src={`/assets/kupon/${blog.image_filename}`} alt={blog.blogname} />
                            <h1>{blog.blogname}</h1>
                            <p className="blog-meta">
                                <span className="author"><i className="fas fa-user"></i> {blog.author}</span>
                                <span className="date">
                                                                    <i className="fas fa-calendar"></i>
                                                                    {new Date(blog.date).toLocaleString("tr-TR", {
                                                                        day: "2-digit",
                                                                        month: "2-digit",
                                                                        year: "numeric",
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </span>                              </p>
                            <p className="excerpt">{blog.feedback}</p>
                            

                        </div>
                                                    {/* Show the edit button only if the user has 'admin' or 'editor' role */}
                                                    {(userRole === 'admin' || userRole === 'editor') && (
                                <button className='detail-button' onClick={handleEditClick}>Düzenle</button>
                            )}
                    </div>
                </div>
            </div>

            {isEditing && (
                <form className='detail-form' onSubmit={handleSubmit}>
                    <input
                        className='form-input'
                        type="text"
                        name="blogname"
                        value={updatedBlog.blogname}
                        onChange={handleInputChange}
                    />
                    <textarea
                        className='form-input'
                        name="feedback"
                        value={updatedBlog.feedback}
                        onChange={handleInputChange}
                    />
                        <div className="button-container">

                    <button className='detail-button' type="submit">Kaydet</button>
                    <button className='detail-button' type="button" onClick={() => setIsEditing(false)}>İptal</button>
                    </div>

                </form>
            )}

            <CommentSection blogId={blog.id} />
        </div>
    );
}

export default BlogDetail;
